// eslint-disable-next-line
import { Component, CustomElement } from "../../core/CustomElement";

enum DialogSize {
  small = "small",
  medium = "medium",
  big = "big",
}

@Component("ccc-dialog", {
  template: require("./dialog.html").default,
  style: require("./dialog.scss").default,
  observedAttributes: ["size"],
})
// eslint-disable-next-line
export default class CCCDialog extends CustomElement {
  private closeBind = this.close.bind(this);
  private closeByEscapeKeyBind = this.closeByEscapeKey.bind(this);
  private onCloseCallback: () => void = null;

  constructor() {
    super();
  }

  attributeChangedCallback(
    attr: string,
    oldValue: string,
    newValue: string
  ): void {
    const $dialog = this.shadowDom.querySelector(".dialog");
    if (attr == "size") {
      if (newValue in DialogSize) {
        $dialog.classList.remove(oldValue);
        $dialog.classList.add(newValue);
      }
    }
  }

  /* ••[2]•••••••••• Implementation ••••••••••••••• */
  public set size(value: DialogSize) {
    const $dialog = this.shadowDom.querySelector(".dialog");
    for (const size in DialogSize) {
      $dialog.classList.remove(size);
    }
    $dialog.classList.add(value);
  }

  public open(): void {
    this.shadowDom.querySelector(".dialog").setAttribute("open", "open");
    document.querySelector("body").style.overflow = "hidden";

    const $slotCloseTrigger: HTMLElement = this.getSlotCloseTrigger();

    window.addEventListener("keyup", this.closeByEscapeKeyBind);

    if ($slotCloseTrigger) {
      $slotCloseTrigger.addEventListener("click", this.closeBind);
    } else {
      this.getDialogCloseButton().addEventListener("click", this.closeBind);
    }
  }

  public onClose(callback: () => void): void {
    this.onCloseCallback = callback;
  }

  public close(): void {
    this.shadowDom.querySelector(".dialog").removeAttribute("open");
    document.querySelector("body").style.overflow = "visible";

    const $slotCloseTrigger: HTMLElement = this.getSlotCloseTrigger();

    if ($slotCloseTrigger) {
      $slotCloseTrigger.removeEventListener("click", this.closeBind);
    } else {
      this.getDialogCloseButton().removeEventListener("click", this.closeBind);
    }

    const event = new Event("ccc-dialog-closed");
    this.dispatchEvent(event);

    if (this.onCloseCallback) {
      this.onCloseCallback();
    }
  }

  private closeByEscapeKey(event: KeyboardEvent): void {
    if (event.key === "Escape") {
      this.close();
      window.removeEventListener("keyup", this.closeByEscapeKeyBind);
    }
  }

  private getSlotCloseTrigger(): HTMLElement | null {
    const $slot: HTMLSlotElement = this.shadowRoot.querySelector("slot");
    if ($slot) {
      const $assignedElements: Array<Node> = $slot.assignedElements();

      if ($assignedElements.length) {
        const $closeTrigger: HTMLElement = (
          $assignedElements[0] as HTMLElement
        ).querySelector("[close-dialog]");

        return $closeTrigger;
      }
    }

    return null;
  }

  private getDialogCloseButton(): HTMLButtonElement {
    let $dialogCloseButton: HTMLButtonElement = this.shadowDom.querySelector(
      ".dialog-close-button"
    );

    if (!$dialogCloseButton) {
      $dialogCloseButton = document.createElement("button");
      $dialogCloseButton.classList.add("dialog-close-button");
      $dialogCloseButton.innerText = "✖";

      this.shadowDom
        .querySelector(".dialog-container")
        .appendChild($dialogCloseButton);
    }

    return $dialogCloseButton;
  }
}
